var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _BonusCardApp_instances, _BonusCardApp_getPlatform;
import { gte, lte } from 'semver';
class AppPlatform {
    constructor(platformName, platformVersion) {
        this.platformName = platformName;
        this.platformVersion = platformVersion;
    }
    /**
     * Run a comparison against the current version and return if its an NEWER version.
     * @param version The version you want it to be greater than. Example: {}
     * @returns {boolean} true is current version is greater than the specified one. Note: will return false if
     *  runs on a platform which is not supported. E.g. {Android: 1.0.0} but when runs on iOS will always be false.
     */
    isGreaterOrEqualThan(version) {
        try {
            const platformVersion = version === null || version === void 0 ? void 0 : version[this.platformName];
            if (!platformVersion)
                return false;
            return gte(this.platformVersion || '', platformVersion);
        }
        catch (error) {
            console.warn(`Failed to parse app version. ${this.platformVersion}`);
            return false;
        }
    }
    /**
     * Run a comparison against the current version and return if its an OLDER version.
     * @param version The version you want it to be less than
     * @returns {boolean} true if current version is less than current
     */
    isLessOrEqualThan(version) {
        try {
            const platformVersion = version === null || version === void 0 ? void 0 : version[this.platformName];
            if (!platformVersion)
                return false;
            return lte(this.platformVersion || '', platformVersion);
        }
        catch (error) {
            console.warn(`Failed to parse app version. ${this.platformVersion}`);
            return false;
        }
    }
    /**
     * Is the platform the iOS app?
     * @returns {boolean}
     */
    isiOS() {
        return this.platformName == "iOS";
    }
    /**
     * Is the platform the android app?
     * @returns {boolean}
     */
    isAndroid() {
        return this.platformName == "Android";
    }
}
export default class BonusCardApp {
    constructor(uaString) {
        var _a;
        _BonusCardApp_instances.add(this);
        this.userAgent = uaString || (typeof window !== 'undefined' ? (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent : '');
        this.platform = __classPrivateFieldGet(this, _BonusCardApp_instances, "m", _BonusCardApp_getPlatform).call(this);
    }
    /**
     * Check if request is from bonus card or not
     * @returns {boolean} are you on the app?
     */
    isApp() {
        return this.platform !== null;
    }
}
_BonusCardApp_instances = new WeakSet(), _BonusCardApp_getPlatform = function _BonusCardApp_getPlatform() {
    try {
        const androidUserAgentRegex = /^Iceland(?: QA)*\/([\d.]*) Dalvik\/\d+(.\d)+.*/i;
        const iOSUserAgentRegex = /^Iceland(?: QA)*\/([\d.]*) \(iOS (?:[\d.]*)\)/i;
        // In the SSR we don't have a window, but the order details page is rendered on the SSR. So if
        // no window is present just rely on the regex of the UA.
        const windowObj = typeof window !== 'undefined' ? window : { webkit: {}, appInterface: {} };
        // Check if Android OS
        if (androidUserAgentRegex.test(this.userAgent) && 'appInterface' in windowObj && windowObj.appInterface != undefined) {
            const match = androidUserAgentRegex.exec(this.userAgent);
            return new AppPlatform("Android", match === null || match === void 0 ? void 0 : match[1]);
        }
        // Check if IOS
        else if (iOSUserAgentRegex.test(this.userAgent) && 'webkit' in windowObj && windowObj.webkit != undefined) {
            const match = iOSUserAgentRegex.exec(this.userAgent);
            return new AppPlatform("iOS", match === null || match === void 0 ? void 0 : match[1]);
        }
        return null;
    }
    catch (e) {
        console.error(e);
        // Not in App, ignore
        return null;
    }
};
